<template>
    <div class="mx-auto max-w-[500px]">
        <login-modal :org-level="true" />
    </div>
</template>

<script setup lang="ts">
import LoginModal from '~/components/Verification/LoginModal.vue'
import {
    definePageMeta,
    useHead,
    useLayoutMode,
    useRouteLink,
    useViewer
} from '#imports'
import { useRoute } from '#app'
import { useRouter } from 'vue-router'
import { watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'

definePageMeta({
    layout: 'org'
})

const route = useRoute()
const router = useRouter()
const { preserveModeLink } = useLayoutMode()
const { profileLink } = useRouteLink()
const viewer = useViewer()
const { t } = useI18n({ useScope: 'global' })

// Identify sign-in in browser tabs and history, including after a language change.
useHead({
    title: () => t('signIn')
})

watchEffect(() => {
    if (viewer.value !== undefined) {
        if (
            typeof route.query.redirect === 'string' &&
            route.query.redirect.length > 0
        ) {
            router.push(
                preserveModeLink(decodeURIComponent(route.query.redirect))
            )
        } else {
            router.replace(profileLink())
        }
    }
})
</script>
